import React from "react";

// components
import { Button } from "../../_commons/Button";
import Popover from "../../_commons/Popover";

// assets
import HelpIcon from "../../_commons/HelpIcon";
import { ButtonIcon } from "../../_commons/ButtonIcon";

const SectionHeader = ({
	title,
	headerLeft,
	headerRight,
	showHelpBtn = false,
	handlePiperAcademy,
	isPageScrolled = false,
	newBtn = false,
	downloadCSV = false,
	renderDownloadOption,
	description,
	descToolTip
}) => {
	return (
		<div
			className={"analytics-section-header" + (isPageScrolled ? " scrolled" : "")}
			style={{ alignItems: "flex-start" }}
		>
			<div className="section-header-left">
				<div className="title-div">
					{title || headerLeft}
					{newBtn && (
						<div className="new-btn">
							New <span class="diagonal-animation"></span>
						</div>
					)}
				</div>
				{description && <TitleDescription description={description} descToolTip={descToolTip} />}
			</div>
			<div className="section-header-right">
				{downloadCSV && renderDownloadOption()}
				{showHelpBtn && handlePiperAcademy && (
					<div className="help-btn-container">
						<Button clickHandler={handlePiperAcademy} type="secondary">
							<HelpIcon />
							<span>Help</span>
						</Button>
					</div>
				)}
				{headerRight}
			</div>
		</div>
	);
};
export default SectionHeader;

const TitleDescription = ({ description, descToolTip }) => {
	const renderPopover = (desc) => {
		return <div className="description">{desc}</div>;
	};

	return (
		<>
			<div className="title-desc">
				<div>{description}</div>
				{descToolTip && (
					<Popover data={descToolTip} showOnHover={true} renderPopover={renderPopover} classes="middle">
						<ButtonIcon icon="info" color="#AAAAAA" />
					</Popover>
				)}
			</div>
		</>
	);
};
